/**
 * Notificações do sino do header: uma lista de itens com tipo. Hoje há um tipo
 * só, os tickets que precisam da ação da pessoa (a mesma consulta da contagem
 * de pendentes). Um tipo novo entra em `HeaderNotificationKind`, ganha ícone
 * aqui e uma fonte em `useHeaderNotifications`.
 */
import {Ticket} from 'app/modules/tickets/models/Ticket';
import {needsActionTicketUrl} from 'app/modules/tickets/ticketsLinks';

export type HeaderNotificationKind = 'ticket';

export type HeaderNotification = {
  /**
   * Muda quando o item muda: um ticket que volta a precisar da ação da pessoa
   * (outra pessoa agiu nele) é não lido de novo.
   */
  id: string;
  kind: HeaderNotificationKind;
  title: string;
  /** Segunda linha (no ticket, a oficina). */
  context?: string;
  /** Quando o item apareceu (ISO); vira "há 5 min". */
  at: string;
  to: string;
};

export const NOTIFICATION_KIND_ICON: Record<HeaderNotificationKind, string> = {
  ticket: 'bi-ticket-detailed',
};

/**
 * Ticket que precisa da ação da pessoa. O `needs_action` acende quando outra
 * pessoa atribui ou age no ticket e essa escrita move o `updated_at`: é o
 * "quando" da notificação e, com o uid, a identidade dela.
 */
export const ticketNotification = (ticket: Ticket): HeaderNotification => ({
  id: `ticket:${ticket.uid}:${ticket.updated_at}`,
  kind: 'ticket',
  title: ticket.title?.trim() || `Ticket #${ticket.reference_id}`,
  context: ticket.account_name || ticket.contact_name || undefined,
  at: ticket.updated_at,
  to: needsActionTicketUrl(ticket.uid),
});
